import React from 'react';

import styled from 'styled-components';

import SelectAdvancedFilter from 'components/lib/SelectAdvancedFilter';

import { USER_GROUPS } from '../../../constants';
import { useShopRequestsContext } from '../ShopRequestsContext';
import { useShopRequestsDataContext } from '../ShopRequestsDataContext';

const StyledFilter = styled(SelectAdvancedFilter)`
  margin-right: 5px;
`;

type Props = {
  fieldKey: 'shoppers' | 'auditors';
  Label: 'Assignee' | 'Auditor';
};

const ShopRequestsUserFilter = ({ fieldKey, Label }: Props) => {
  const { staffUsers } = useShopRequestsContext();
  const { filters, setFilters } = useShopRequestsDataContext();

  const currentValue = filters[fieldKey] ?? [];

  const onChange = (values: any[]) => {
    setFilters({ ...filters, [fieldKey]: values.map((item: any) => item.value) });
  };

  const mysteryShopAdmins = staffUsers?.filter((u) => u.groups?.includes(USER_GROUPS.MYSTERY_SHOP_ADMIN)) ?? [];
  const shoppers = staffUsers?.filter((u) => !u.groups?.includes(USER_GROUPS.MYSTERY_SHOP_ADMIN)) ?? [];

  const sourceList = fieldKey === 'auditors' ? mysteryShopAdmins : shoppers;

  const options = [
    ...sourceList.map((user) => ({ value: user.userId, label: user.name })),
    { value: 0, label: 'Unassigned ' },
  ];

  return (
    <StyledFilter
      options={options}
      defaultValue={currentValue}
      dataTestId="sr-filter-assignee"
      onSelect={onChange}
      placeholder={Label}
    />
  );
};

export default ShopRequestsUserFilter;
